export default "__VITE_ASSET__iaRPAGM1__"